<template>
  <div class="container">
    <div class="nav">
      <div class="nav_con">
        <div class="left_nav">
          <div class="home">
            <span class="iconfont icon-shouye8"></span>
            <router-link :to="{ path: '/' }" class="home">{{ $t(`page.goodsDetail.home`) }}</router-link>
          </div>
          <div class="collect cursors" @click="AddFavorite()">
            <span class="iconfont icon-shoucang3"></span>
            {{ $t(`page.index.collectSite`) }}
          </div>
        </div>
        <div class="right_nav">
          <router-link :to="{ path: '/trackOrder' }" class="orders">{{ $t(`router.trackOrder`) }}
          </router-link>
          <div class="line"></div>
          <div class="apply" @click="goMerSettled()">
            {{ $t(`router.news`) }}
          </div>
          <div class="line"></div>
          <div class="mobile" @click="go()">
            {{ $t(`page.index.mobileMall`) }}
          </div>
        </div>
      </div>

    </div>
    <div class="header" :class="navBarFixed == true ? 'navBarWrap' : ''">
      <div class="header_con">
        <!-- <span class="iconfont icon-more"></span> -->
        <span class="iconfont icon-more" @mouseenter="show" @click="show"></span>
        <div class="logo">
          <router-link :to="{ path: '/' }"><img :src="logoUrl" alt=""></router-link>
        </div>
        <div class="input">
          <div class="left_select">
            <input type="text" :placeholder="$t(`page.goodsSearch.placeSearch`)" v-model="search">
          </div>
          <div v-if="hotSearchList.length" class="right_select">
            <div class="keyword" @click="(search = item.name) && submit()" v-for="item in hotSearchList.slice(0, 3)"
              :key="item.id">
              {{ item.name }}
            </div>
           
          </div>
          <div class="search" @click="submit">
            <span class="iconfont icon-sousuo"></span>
          </div>
        </div>
        <el-dropdown>
          <div class="code">
            <span class="iconfont icon-yuyanqiehuan"></span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <template v-for="(item, index) in langList">
              <el-dropdown-item v-for="(items, idx) in item.intro" :key="idx" @click.native="languagelTab(items)">
                {{ $t(`userDrawer.language[${idx}].name`) }}
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>

        <router-link to="/order/shopping_cart" class="cartNum">
          <div class="car">
            <span class="iconfont icon-gouwuche"></span>
            <span v-if="$store.state.cartNumber" class="num">{{ $store.state.cartNumber }}</span>
          </div>
        </router-link>

        <div class="pic">
          <img :src="userInfo.avatar ? userInfo.avatar : defaultPic">
        </div>
        <div v-if="!userInfo.token" class="login" @click="longin">{{ $t(`page.users.login.sign`) }}</div>
        <div v-else>
          <el-dropdown>
            <span class="login el-dropdown-link line1">
              {{ userInfo.email }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <div class="userBox acea-row row-middle">
                <div class="avatarPic">
                  <img :src="userInfo.avatar ? userInfo.avatar : defaultPic">
                </div>
                <div>
                  <!-- <div class="nickname">{{ userInfo.nickname }}</div> -->
                  <!-- <div v-show="userInfo.phone" class="count">{{ userInfo.phone }}</div> -->
                  <div v-show="userInfo.email" class="count">{{ userInfo.email }}</div>
                </div>
              </div>
              <el-dropdown-item v-for="(menu, index) in userMenu" :key="menu.id" @click.native="goPage(menu)">
                <div class="dropdownBox" v-show="menu.pc_url && menu.pc_url != ' '">
                  {{ menu.name }}</div>
              </el-dropdown-item>
              <div class="userInfo">
                <el-divider></el-divider>
              </div>
              <el-dropdown-item v-for="(menu, index) in menus" :key="menu.id" @click.native="goPage(menu)">
                <div class="dropdownBox" v-show="menu.pc_url && menu.pc_url != ' '">{{ menu.name }}</div>
              </el-dropdown-item>
              <el-button @click="longOut" class="btn">{{ $t(`page.users.userInfo.logOut`) }}</el-button>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="category acea-row" @mouseleave="leave()" v-if="hide">
          <div class="sort">
            <div class="item acea-row row-between-wrapper" :class="index === current ? 'bg-color' : ''"
              v-for="(item, index) in cates" :key="index" @mouseenter="enter(index)">
              <div class="name line1">{{ item.name }}</div>
            </div>
          </div>
          <div class="sortCon" @mouseleave="show" v-if="seen && categoryCurrent">
            <div class="erSort">
              <div class="item acea-row row-middle" v-for="(item, index) in categoryCurrent" :key="index">
                <div class="name line1"  @click="goCate(item)">{{ item.name }}</div>
                <!-- <div class="cateList">
                  <span class="cateItem" @click="goCate(item)">
                    {{ items.name }}
                  </span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie';
import { configMap } from '@/utils/validate.js'
import LogoUrl from '@/assets/images/logo.jpg'
import { getCurrentToken, isGuestToken } from '@/utils/guestToken';
export default {
  name: "headers",
  mixins: [],
  data() {
    return {
      logoUrl: LogoUrl,
      categoryCurrent: [],
      langList: [
        {
          name: '语言',
          current: 1,
          intro: [{name:'zh-CN', value:'1'}, {name:'es', value:'2'}]
        }
      ],
      // menus: [],
      cates: [],
      seen: false,
      hide: false,
      navBarFixed: false,
      headerList: [],
      search: "",
      // userInfo: {},
      showCode: false,
      hotSearchList: [],
      searchList: [],
      list: [],
      dialogVisible: false,
      current: 1,
      info: '',
      isShow: true,
      appidNum: '',
      hosts: '',
      fromPath: '',
      disabled: false,
      defaultPic: require("../assets/images/morentou.png"),
      cid: null,
      // userMenu: [
      //   {
      //     id: 111,
      //     name: this.$t(`page.user.myOrder`),
      //     pc_url: '/users/order_list'
      //   },
      //   // {
      //   //   id: 222,
      //   //   name: this.$t(`page.users.goodsReturn.refundList`),
      //   //   pc_url: '/users/refund_list'
      //   // },
      //   // {
      //   //   id: 333,
      //   //   name: this.$t(`page.users.replyList.navTitle`),
      //   //   pc_url: '/users/evaluation_list'
      //   // }
      //   {
      //     id: 444,
      //     name: this.$t(`page.users.wallet.navTitle`),
      //     pc_url: '/users/wallet'
      //   },
      //   {
      //     id: 555,
      //     name: this.$t(`page.users.invoiceList.navTitle`),
      //     pc_url: '/users/invoice_list'
      //   }
      // ]
    }
  },
  computed: {
    userInfo() {
      console.log(this.$store.state, 'userInfo');
      return this.$store.state.userInfo;
    },
    userMenu() {
      return [
        {
          id: 111,
          name: this.$t(`page.user.myOrder`),
          pc_url: "/users/order_list",
        },
        {
          id: 222,
          name: this.$t(`page.users.afterSale.navTitle`),
          pc_url: '/users/after_sale'
        },
        {
          id: 333,
          name: this.$t(`page.users.replyList.navTitle`),
          pc_url: '/users/evaluation_list'
        },
        {
          id: 444,
          name: this.$t(`page.users.wallet.navTitle`),
          pc_url: "/users/wallet",
        },
        {
          id: 555,
          name: this.$t(`page.users.invoiceList.navTitle`),
          pc_url: "/users/invoice_list",
        },
      ];
    },
    menus() {
      return [
        {
          name: this.$t(`page.user.profile`),
          id: 709,
          pc_url: "/users/user_info",
          url: "/pages/users/user_info/index",
        },
        {
          name: this.$t(`page.user.address`),
          id: 710,
          pc_url: "/users/address_list",
          url: "/pages/users/user_address_list/index",
        },
        {
          name: this.$t(`page.user.like`),
          id: 711,
          pc_url: "/users/collection_list",
          url: "/pages/users/user_goods_collection/index",
        },
        // {
        //   name: this.$t(`page.user.service`),
        //   id: 715,
        //   pc_url: "/users/application_record",
        //   url: "/pages/merchant/application_record/index",
        // },
      ];
    },
  },
  // computed: configMap(['logoUrl']),
  watch: {
    $route: {
      handler: function (newVal, oldVal) {
        this.search = newVal.query.title ? newVal.query.title : '';
      },
      // 深度观察监听
      deep: true
    }
  },
  head() {
    // if (this.$route.path == '/') {
    //   this.hide = true;
    //   this.navBarFixed = false;
    // } else {
    //   this.hide = false;
    // }
    if (localStorage.getItem('token')) {
      // this.getMenus();
      this.carCount();
    }
    return {
      title: this.$store.state.titleCon
    }
  },
  created() {
    let token = getCurrentToken();
    console.log(token)
    if (token) {
      // this.getMenus();
      this.carCount();
    }
    if (!localStorage.getItem('homeDataPc')) {
      // this.getHomeIndex()
    }
    // this.getHotSearchList();
    // this.$store.dispatch('getProductClassify')
    // this.getLogoUrl()
  },
  mounted() {
    window.addEventListener('keydown', this.keyDown);
    this.hosts = location.origin + location.pathname;
    this.fromPath = Cookies.get("fromPath");
    window.addEventListener("scroll", this.watchScroll);
  },
  destroyed() {
    window.removeEventListener('keydown', this.keyDown, false);
  },
  methods: {
    getLogoUrl() {
      // this.logoUrl = JSON.parse(localStorage.getItem("homeDataPc"))?.['logoUrl'];
      this.logoUrl = LogoUrl
    },
    getHomeIndex() {
      this.$axios.get("/api/pc/home/index").then(res => {
        localStorage.setItem("homeDataPc", JSON.stringify(res.data));
      })
    },
    carCount() {
      this.$axios.get("/api/index/getCartNum?numType=true&type=total").then(res => {
        this.$store.commit('cartNum', res.data.cartNum);
        this.hotSearchList = res.data.search;
        this.cates = res.data.goodcate
        this.$store.commit("SET_BottomData", res.data.bottom);
        this.$store.commit("SET_ProductClassify", res.data.goodcate);
        // 更新币种单位到Vuex
        this.$store.commit("SET_CURRENCY_UNIT", res.data.unit);
      })
    },
    /**
     *
     * 语言切换
     */
    languagelTab(n) {
      this.$i18n.locale = n.name;
      Cookies.set('locale', n.value)
      this.$store.commit('SET_LANG', n.name)
      location.reload();
    },
    /**
     *
     * 退出登录
     */
    async longOut() {
      let val = Cookies.get('auth.strategy')
      await this.$axios.post('/api/index/logout').then(res => {
        this.$store.commit('cartNum', 0);
        localStorage.clear();
        this.$store.commit('SET_USER_INFO', {});
        this.$router.replace({
          path: '/'
        })
      })
      localStorage.clear();
      location.reload();
      // })
    },
    //跳入移动商城地址
    go(url) {
      window.open('https://h5.thefinenet.com/', '_blank')
    },
    // 商品分类
    goCate(items) {
      console.log(items, 'items')
      this.cid = items.id
      const query = {
        cid: items.id,
        // title: items.name ? items.name : ''
      };
      
      // 检查是否是相同路由
      if (this.$route.path === '/goods/goods_search' && 
          this.$route.query.cid === String(items.id) && 
          this.$route.query.title === query.title) {
        return; // 相同路由，不跳转
      }
      
      this.$router.push({
        path: '/goods/goods_search',
        query: query
      }).catch(err => {
        // 捕获重复导航错误，避免控制台警告
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    /**
     *
     * 商户入驻
     */
    goMerSettled() {
      this.$router.push({
        path: `/news`,
        query: { menuCur: 70 }
      });
    },
    goPage(menu) {
      this.$router.push({
        path: `${menu.pc_url}`,
        query: { menuCur: menu.id }
      });
    },
    /**
     *
     * 获取菜单
     */
    getMenus() {
      let data = [
        {
          name: this.$t(`page.user.profile`),
          id: 709,
          pc_url: "/users/user_info",
          url: "/pages/users/user_info/index",
        },
        {
          name: this.$t(`page.user.address`),
          id: 710,
          pc_url: "/users/address_list",
          url: "/pages/users/user_address_list/index",
        },
        {
          name: this.$t(`page.user.like`),
          id: 711,
          pc_url: "/users/collection_list",
          url: "/pages/users/user_goods_collection/index",
        },
        {
          name: this.$t(`page.user.service`),
          id: 715,
          pc_url: "/users/application_record",
          url: "/pages/merchant/application_record/index",
        },
      ]
      this.menus = data
    },
    longin() {
      this.$store.commit("isLogin", true);
      this.$store.commit("isTourists", false);
    },
    // getHotSearchList() {
    //   this.$axios.get("/api/front/search/keyword").then(res => {
    //     this.hotSearchList = res.data || [];
    //   })
    // },
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (this.$route.path == '/' && scrollTop > 120) {
        this.navBarFixed = true;
        this.hide = false;
      } else if (this.$route.path == '/' && scrollTop < 120) {
        this.navBarFixed = false;
        this.hide = false;
      } else if (this.$route.path !== '/' && scrollTop > 120) {
        this.navBarFixed = true;
      } else if (this.$route.path !== '/' && scrollTop < 120) {
        this.navBarFixed = false;
      }
    },
    AddFavorite() {
      let url = window.location;
      let title = document.title;
      let ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("360se") > -1) {
        this.$message(this.$t(`message.tips.browser`));
      }
      else if (ua.indexOf("msie 8") > -1) {
        window.external.AddToFavoritesBar(url, title); //IE8
      }
      else if (document.all) {
        try {
          window.external.addFavorite(url, title);
        } catch (e) {
          this.$message(this.$t(`message.tips.nubrowser`));
        }
      }
      else if (window.sidebar) {

        this.$message(this.$t(`message.tips.nubrowser`));
      }
      else {
        this.$message(this.$t(`message.tips.nubrowser`));
      }
    },
    submit() {
      const query = {
        title: this.search ? this.search.trim() : '',
        cid: this.cid
      };
      
      // 检查是否是相同路由
      if (this.$route.path === '/goods/goods_search' && 
          this.$route.query.title === query.title && 
          this.$route.query.cid === query.cid) {
        return; // 相同路由，不跳转
      }
      
      this.$router.push({
        path: '/goods/goods_search',
        query: query
      }).catch(err => {
        // 捕获重复导航错误，避免控制台警告
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    handleClose() {
      this.dialogVisible = false
    },
    showLogin() {
      this.$store.commit("isLogin", true);
    },
    keyDown(e) {
      // this.submit()
    },
    enter(index) {
      this.seen = true;
      this.hide = true;
      this.current = index;
      this.categoryCurrent = this.cates[index].children;
    },
    leave() {
      if (this.$route.path == '/') {
        this.seen = false;
        this.hide = true
      } else {
        this.seen = false;
      }

    },
    show() {
      console.log(this.hide)
      this.hide = !this.hide
    }
  }
}
</script>
<style scoped lang="scss">
.userInfo {
  ::v-deep.el-divider--horizontal {
    margin: 10px 0 !important;
  }
}

.dropdownBox {
  width: 245px;
}

.btn {
  margin: 15px 94px;
}

.userBox {
  padding: 10px 20px 20px 20px;

  .avatarPic {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .nickname {
    font-size: 16px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
    color: #333333;
    margin-bottom: 5px;
  }

  .count {
    font-size: 12px;
    font-family: ArialMT;
    color: #999999;
  }
}

.container {
  width: 100%;
  // position: fixed;
  z-index: 99;

  .nav {
    background: #F4F4F4;

    .nav_con {
      width: 1200px;
      height: 30px;
      margin: auto;
      display: flex;
      justify-content: space-between;
      background: #F4F4F4;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 14px;

      .left_nav {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;

        .icon {
          font-size: 12px;
          background: #8A8A8A;
        }

        .home {
          margin-right: 20px;
          cursor: pointer;
        }
      }

      .right_nav {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;

        .orders {
          margin-right: 10px;
        }

        .line {
          width: 1px;
          height: 10px;
          background: #000000;
          opacity: 0.1;
        }

        .apply {
          margin: 0 10px;
          cursor: pointer;
        }

        .mobile {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }

  .header {
    width: 100%;
    height: 90px;
    margin: auto;
    background: #FFFFFF;

    .header_con {
      width: 1200px;
      height: 90px;
      margin: auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;

      .icon-more {
        font-size: 22px;
        color: #000000;
        cursor: pointer;
      }

      .logo {
        width: 42px;
        height: 42px;
        margin: 0 20px 0 20px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .input {
        width: 750px;
        height: 40px;
        border: 1px solid #E93323;
        border-radius: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 20px;

        .left_select {
          input {
            width: 435px;
            outline: none;
            border: 0;
          }
        }

        .right_select {
          display: flex;
          align-items: center;

          .keyword {
            width: 62px;
            height: 16px;
            background: #EEEEEE;
            border-radius: 20px;
            font-size: 12px;
            font-family: ArialMT;
            color: #999999;
            line-height: 16px;
            text-align: center;
            margin-right: 5px;
            cursor: pointer;
          }

        }
        .search {
          width: 60px;
          height: 40px;
          background: #E93323;
          border-radius: 20px;
          text-align: center;
          line-height: 40px;
          color: #fff;
          margin-left: 11px;
          cursor: pointer;
        }
      }

      .code,
      .car {
        width: 34px;
        height: 34px;
        background: #FFFFFF;
        border: 1px solid #999999;
        border-radius: 50%;
        text-align: center;
        line-height: 34px;
        cursor: pointer;
        position: relative;

        .num {
          position: absolute;
          top: -6px;
          left: 21px;
          color: #fff;
          font-size: 12px;
          padding: 2px 5px;
          border-radius: 100px;
          background-color: #E93323;
          display: inline-block;
          font-weight: 800;
          line-height: 14px;
        }
      }

      .code {
        margin-left: 24px;
      }

      .car {
        margin: 0 20px;

        .icon {
          font-size: 16px;
          color: #333;
        }
      }

      .pic {
        width: 30px;
        height: 30px;
        background: #EEEEEE;
        border-radius: 50%;
        margin-right: 10px;
        text-align: center;
        line-height: 30px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .login {
        font-size: 14px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #333333;
        line-height: 14px;
        cursor: pointer;
        width: 90px;
        display: block;
      }

    }
  }
}

.navBarWrap {
  position: fixed;
  top: 0;
  z-index: 999;
}

.category {
  position: absolute;
  top: 90px;
  left: 0;
  z-index: 9;
}

.sort {
  width: 208px;
  height: 480px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 14px 0;

  .item {
    height: 39px;
    padding: 0 21px;

    .name {
      width: 150px;
      cursor: pointer;
    }

    .iconfont {
      font-size: 10px;
    }
  }
}

.sortCon {
  width: 772px;
  height: auto;
  background-color: #fff;
  box-shadow: 5px 1px 10px rgba(0, 0, 0, 0.2);
  border: 1px solid #f2f2f2;
  border-left: 0;
  border-right: 0;
  padding: 0 5px 20px 20px;

  .title {
    padding-bottom: 8px;
    border-bottom: 1px solid #f1f1f1;

    .font-color {
      padding-bottom: 8px;
      font-size: 16px;
      border-bottom: 2px solid #e93323;
    }
  }

  .erSort {
    min-height: 480px;

    .item {
      margin-top: 23px;
      width: 100%;
      max-height: 100px;
      border-width: 1px;
      border-style: none none solid none;
      border-color: #eee;
      cursor: pointer;

      .name {
        color: #333333;
        font-size: 14px;
        width: 100%;
        font-family: Arial-BoldMT, Arial;

        &:hover {
          color: #e93323;
        }
      }

      .item-child {
        margin: 12px 30px 10px 0;
        font-size: 14px;
        color: #333333;
        font-family: ArialMT;
      }

      .pictrue {
        width: 50px;
        height: 50px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .cateList {
      margin: 12px 30px 10px 0;
      font-size: 14px;
      color: #333333;
      font-family: ArialMT;

      .cateItem {
        text-align: center;
        padding: 0 20px;
        display: inline-block;
        cursor: pointer;

        &:hover {
          color: #e93323;
        }
      }
    }
  }
}
</style>
